var _rect, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCreators1(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 50,
    height: 50,
    rx: 20,
    fill: "#8C9EFF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M38.286 11H11.823a.824.824 0 00-.823.823v11.53c0 .455.369.823.823.823h26.463a.824.824 0 00.824-.823v-11.53a.824.824 0 00-.824-.823z",
    fill: "#FFDA2D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M39.11 11.823v11.53a.824.824 0 01-.824.823H25.055V11h13.231c.455 0 .824.369.824.823z",
    fill: "#FDBF00"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M20.059 25.823h-8.236a.824.824 0 00-.823.824v11.53c0 .454.369.823.823.823h8.236a.824.824 0 00.823-.824v-11.53a.824.824 0 00-.823-.823z",
    fill: "#0097F0"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M38.286 25.823H23.353a.824.824 0 00-.824.824v11.53c0 .454.369.823.824.823h14.933a.824.824 0 00.824-.824v-11.53a.824.824 0 00-.824-.823z",
    fill: "#0052C2"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M39.11 26.647v11.53a.824.824 0 01-.824.823H25.055V25.823h13.231c.455 0 .824.37.824.824z",
    fill: "#003481"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M34.273 28.261l1.175-.984a.824.824 0 00-.167-1.37l-8.96-4.383a.824.824 0 00-1.16.944l2.512 9.79a.824.824 0 001.326.426l1.172-.982 1.248 1.496a.824.824 0 001.162.104l2.84-2.383a.823.823 0 00.103-1.159l-1.25-1.499z",
    fill: "#FF641A"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M35.524 29.76a.824.824 0 01-.103 1.159l-1.19 1-8.777-10.304a.809.809 0 01.866-.091l8.961 4.382a.824.824 0 01.167 1.372l-1.174.984 1.25 1.498z",
    fill: "#F03800"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M16.765 14.294a2.474 2.474 0 00-2.471 2.47v3.295a.824.824 0 001.647 0v-.824h1.647v.824a.824.824 0 001.647 0v-3.294a2.473 2.473 0 00-2.47-2.471zm-.824 3.294v-.823a.824.824 0 011.647 0v.823h-1.647zM22.53 14.294h-.824a.824.824 0 00-.824.823v4.942c0 .454.369.823.824.823h.823a3.298 3.298 0 003.294-3.294 3.298 3.298 0 00-3.294-3.294zm0 4.941v-3.294c.908 0 1.646.739 1.646 1.647s-.738 1.647-1.647 1.647z",
    fill: "#FE9022"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M25.055 15.476V19.7c.48-.572.769-1.31.769-2.112 0-.804-.289-1.54-.769-2.112zM28.294 16.49h6.588a.824.824 0 000-1.647h-6.588a.824.824 0 000 1.647zM34.883 18.137h-6.589a.824.824 0 000 1.647h6.588a.824.824 0 000-1.647z",
    fill: "#FF641A"
  })));
}
export default "/_next/static/media/creators1.1924a173ec848126dfad64f122ac8c6d.svg";
export { SvgCreators1 as ReactComponent };